<template>

 <v-dialog v-model="showDialog" width="1200px">
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="close">
              Fechar
            </v-btn>
          </v-card-actions>
          <v-card-title>
            <span class="headline">Selecionar ítem</span>
          </v-card-title>

           <v-card-text>
              <br />
              <v-row class="ma-4">
                <v-select
                  v-model="typeSearch"
                  @change="changeType"
                  :items="itemsDeviceType"
                    item-text="text"
              item-value="value"
                  label="Tipo de produto"
                  dense
                >
                </v-select>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
              </v-row>
            </v-card-text>


          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 300px" class="text-left">Código</th>
                    <th class="text-left">Descrição</th>

                    <th class="text-right">Adicionar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in itemsSearch" v-bind:key="item.id">
                    <td>{{ item.code }}</td>
                    <td>{{ item.description }}</td>

                    <td class="text-right">
                      <v-btn class="primary" @click="addProduct(index)"
                        >+</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>

</template>

<script>

export default {
    name: "modal-devices",
    props:["devices","showDialog", "section","deviceTypes"],
    data(){
        return{
            itemsSearch:[],
            typeSearch: "inverter",
            typeNames:{
                inverter:"Inversor",
                module:"Módulo",
                accessory:"Acessório",
                cable:"Cabo",
                connector:"Conector",
                rail:"Trilho",
                service:"Serviço",
                stringbox:"Stringbox",
                structure:"Estrutura",
                transformer:"Transformador",
                generator:"Kit fechado"
                

            }              
        }
    },
    
    watch: {
      showDialog (val) {
          //Load Different type 
          this.typeSearch = this.deviceTypes[0];
          this.changeType();
       }
     },
    computed: {
      itemsDeviceType:function () {
        var items= [];
        for (var a = 0; a <this.deviceTypes.length; a++){
          items.push( {value:this.deviceTypes[a], text:this.typeNames[this.deviceTypes[a]]});
        }
        // `this` points to the vm instance
        return items;
      }
    },
  
     methods: {
        changeType() {
         // alert("changedType")
          this.itemsSearch = this.devices.filter(
            (element) => element.deviceType == this.typeSearch
          );
        },
       close(){
        // alert("close")
          this.$emit("close")
       },
        addProduct(index) {
            var d = Object.assign({}, this.itemsSearch[index]);
            this.$emit("addDevice", d, this.section)
            //alert(index)
        },
    
    }
    
}
</script>


<style scoped>

</style>